import samsung from '../assets/png/projects/samsung.PNG'
import MyNotes from '../assets/png/projects/MyNotes.PNG'
import mytheresa from '../assets/png/projects/mytheresa.PNG'
import Overstock from '../assets/png/projects/Overstock.PNG'
import bewkoof from '../assets/png/projects/bewkoof.PNG'
import youtube from '../assets/png/projects/youtube.PNG'
import Weather from '../assets/png/projects/Weather.PNG'
import EcomReact from '../assets/png/projects/EcomReact.PNG'
import Financely from '../assets/png/projects/financely.PNG'
import shop_vanillaJS from '../assets/png/projects/shop_vanillaJS.PNG'
import lead_app from '../assets/png/projects/lead_app.PNG'
import login_app from '../assets/png/projects/login_app.PNG'
import pizza_html_css from '../assets/png/projects/pizza_html_css.PNG'
import bootstrap_ui from '../assets/png/projects/bootstrap_ui.PNG'
import quizz_app_vanillaJS from '../assets/png/projects/quizz_app_vanillaJS.PNG'
import social_media_reactJS from '../assets/png/projects/social_media_reactJS.PNG'
import coin_api_reactJS from '../assets/png/projects/coin_api_reactJS.PNG'
import post_office_reactJS from '../assets/png/projects/post_office_reactJS.PNG'
import crud_redux_toolkit from '../assets/png/projects/crud-redux-toolkit.PNG'
import nasa_app_vanillaJS from '../assets/png/projects/nasa_app_vanillaJS.PNG'
import coin_tracker_vanillaJS from '../assets/png/projects/coin_tracker_vanillaJS.PNG'
import movie_app_reactJS from '../assets/png/projects/movie_app_reactJS.PNG'
import post_office_vanillaJS from '../assets/png/projects/post_office_vanillaJS.PNG'
import todo_app_vanillaJS from '../assets/png/projects/todo_app_vanillaJS.PNG'
import timezone_vanillaJS from '../assets/png/projects/timezone_vanillaJS.PNG'
import student_ms_vanillaJS from '../assets/png/projects/student_ms_vanillaJS.PNG'
import profession_manage_vanillJS from '../assets/png/projects/profession_manage_vanillJS.PNG'
import insta_ui from '../assets/png/projects/insta_ui.PNG'
import restaurant_basic_ui from '../assets/png/projects/restaurant_basic_ui.PNG'




export const projectsData = [
  {
    id: 2,
    projectName: 'Financely Finance Tracker',
    projectDesc: 'This project aims to build a personal finance tracker which has graphs and tables to manage data and csv file download and upload functionality.',
    tags: ['React Js', 'HTML', 'JAVASCRIPT'],
    code: 'https://github.com/dnyaneshwarmagar/personal-finance-tracker',
    demo: 'https://personal-finance-tracker-par.netlify.app/',
    image: Financely
  },
  {
    id: 3,
    projectName: 'Online Shopping Platform',
    projectDesc: 'An app that for shopping different products from fashion , jewellery, electronic, etc. categories',
    tags: ['Javascript', 'HTML', 'CSS'],
    code: 'https://github.com/dnyaneshwarmagar/shopping-platform-app',
    demo: 'https://shoppinga-app-parm.netlify.app/',
    image: shop_vanillaJS
  },
  {
    id: 4,
    projectName: 'Clone of Samsung.com',
    projectDesc: 'This project aims to build an web application Samsung.com which is an online platform for electronic devices and home appliances by Samsung brand.',
    tags: ['HTML', 'CSS', 'JAVASCRIPT'],
    code: 'https://github.com/dnyaneshwarmagar/Project-on-Clonig-of-Samsung-Website',
    demo: 'https://samsung-clone-dnyaneshm-project.netlify.app/',
    image: samsung
  },
  {
    id: 5,
    projectName: 'Clone of Mytheresa.com',
    projectDesc: 'This project aims to build Mytheresa website is an e-commerce website for fashion and design products of all the leading brands. Built frontend, backend and API for this.',
    tags: ['Node js', 'Express Js', 'Mongo DB', 'Ejs'],
    code: 'https://github.com/dnyaneshwarmagar/Project-on-Cloning-of-Mytheresa.com-',
    demo: 'https://github.com/dnyaneshwarmagar/Project-on-Cloning-of-Mytheresa.com-',
    image: mytheresa
  },
  {
    id: 6,
    projectName: 'Clone of Bewakoof.com',
    projectDesc: 'This project aims to build an web application Bewakoof.com which is an e-commerce website for fashion,accessories and style products in India',
    tags: ['HTML', 'CSS', 'JAVASCRIPT'],
    code: 'https://github.com/dnyaneshwarmagar/Project-on-Cloning-of-Bewkoof.com',
    demo: 'https://bewakoof-dnyaneshm-project.netlify.app/',
    image: bewkoof
  },
  {
    id: 7,
    projectName: 'Lead App',
    projectDesc: 'An mern stacked app to store information of leads and have functinality to sort and filter and crud operations',
    tags: ['React Js', 'Express Js', 'Node Js', 'Mongo Db'],
    code: 'https://github.com/dnyaneshwarmagar/lead-app-mern',
    demo: 'https://lead-app-mern-xo8t.vercel.app/',
    image: lead_app
  },
  {
    id: 8,
    projectName: 'Auth App',
    projectDesc: 'An app to do login and signup and also have functionality to reset passowrd using email',
    tags: ['React Js', 'Express Js', 'Node Js', 'Mongo Db'],
    code: 'https://github.com/dnyaneshwarmagar/login-app-mern',
    demo: 'https://login-app-mern-lacq.vercel.app/',
    image: login_app
  },
  {
    id: 9,
    projectName: 'Pizza Restaurant UI',
    projectDesc: 'This project aims to build ui for website of Pizza restaurant mainly focusing on html and css.',
    tags: ['Javascript', 'html', 'css'],
    code: 'https://github.com/dnyaneshwarmagar/pizza-restaurant',
    demo: 'https://pizza-reastaurant.netlify.app/',
    image: pizza_html_css
  },
  {
    id: 10,
    projectName: 'My Youtube App',
    projectDesc: 'In this project tried to implement some functionalites of youtube app. Built with HTML,CSS and Javascript. Used Youtube API.',
    tags: ['HTML', 'CSS', 'Javascript'],
    code: 'https://github.com/dnyaneshwarmagar/projects/tree/main/youtube-clone',
    demo: 'https://my-youtube-app-123456.netlify.app/',
    image: youtube
  },
  {
    id: 11,
    projectName: 'Bootstrap Image Gallery',
    projectDesc: 'designed a complex UI for a website using HTML, CSS, and Bootstrap which has goal to create a responsive, user-friendly, and visually appealing interface that includes various components.',
    tags: ['Bootstrap', 'HTML', 'CSS'],
    code: 'https://github.com/dnyaneshwarmagar/bootstrap-ui',
    demo: 'https://bootstrap-ui-acc.netlify.app/',
    image: bootstrap_ui
  },
  {
    id: 12,
    projectName: 'Quiz App',
    projectDesc: 'quiz app created using HTML, CSS and javascript that includes various sections with questions and mcqs.',
    tags: ['Javascript', 'HTML', 'CSS'],
    code: 'https://github.com/dnyaneshwarmagar/quiz-app-js',
    demo: 'https://quiz-app-acc.netlify.app/',
    image: quizz_app_vanillaJS
  },
  {
    id: 13,
    projectName: 'Travel information App',
    projectDesc: 'An app having information of different travel locations and their details',
    tags: ['React Js', 'Redux Tookit', 'React router dom'],
    code: 'https://github.com/dnyaneshwarmagar/react-social-media',
    demo: 'https://react-social-media-app-acc.netlify.app/',
    image: social_media_reactJS
  },
  {
    id: 14,
    projectName: 'Crypto Coin Info App',
    projectDesc: 'An app having information of crypto coins and their details',
    tags: ['React Js', 'Javascript', 'API'],
    code: 'https://github.com/dnyaneshwarmagar/react-coin-tracker',
    demo: 'https://react-coint-tracker.netlify.app/',
    image: coin_api_reactJS
  },
  {
    id: 15,
    projectName: 'Data management app',
    projectDesc: 'An app having to store data build using redux tookit',
    tags: ['React Js', 'Redux Tookit', 'API'],
    code: 'https://github.com/dnyaneshwarmagar/crud-redux-toolkit',
    demo: 'https://crud-redux-toolkit-paran.netlify.app/',
    image: crud_redux_toolkit
  },
  {
    id: 16,
    projectName: 'React Post Office App',
    projectDesc: 'An app to get list of post offices in required area using pincode',
    tags: ['React Js', 'Javascript', 'API'],
    code: 'https://github.com/dnyaneshwarmagar/react-post-office-api',
    demo: 'https://react-post-office-api.netlify.app/',
    image: post_office_reactJS
  },
  {
    id: 17,
    projectName: 'NASA Picture App',
    projectDesc: 'An app to get NASA pictures taken at particular date.',
    tags: ['Javascript', 'API', 'HTML', 'CSS'],
    code: 'https://github.com/dnyaneshwarmagar/nasa-daily-photos',
    demo: 'https://nasa-daily-photos-acc.netlify.app/',
    image: nasa_app_vanillaJS
  },
  {
    id: 18,
    projectName: 'Vanilla Js Coin Info App',
    projectDesc: 'An app having information of crypto coins and their details',
    tags: ['DOM', 'Javascript', 'API'],
    code: 'https://github.com/dnyaneshwarmagar/coin-tracker',
    demo: 'https://coin-tracker-acc.netlify.app/',
    image: coin_tracker_vanillaJS
  },
  {
    id: 19,
    projectName: 'Movie Info App',
    projectDesc: 'An app having information of movies',
    tags: ['React Js', 'Javascript', 'API'],
    code: 'https://github.com/dnyaneshwarmagar/react-movie-app',
    demo: 'https://react-movie-app-tau-five.vercel.app/',
    image: movie_app_reactJS
  },
  {
    id: 20,
    projectName: 'Vanilla Js Post Office App',
    projectDesc: 'An app to get post offices in certain area of give pin code, also gives time zone and locations info',
    tags: ['React Js', 'Javascript', 'API'],
    code: 'https://github.com/dnyaneshwarmagar/search-post-offices',
    demo: 'https://post-offices-par.netlify.app/',
    image: post_office_vanillaJS
  },
  {
    id: 21,
    projectName: 'Vanilla Js Todo App',
    projectDesc: 'An app having information of crypto coins and their details',
    tags: ['DOM', 'Javascript', 'HTML'],
    code: 'https://github.com/dnyaneshwarmagar/todo-list-js',
    demo: 'https://todo-list-js-acc.netlify.app/',
    image: todo_app_vanillaJS
  },
  {
    id: 22,
    projectName: 'VanillJs Timezone App',
    projectDesc: 'An app to get information related to timezone from current location',
    tags: ['DOM', 'Javascript', 'Web Api'],
    code: 'https://github.com/dnyaneshwarmagar/time-zone-app',
    demo: 'https://time-zone-app-acc.netlify.app/',
    image: timezone_vanillaJS
  },
  {
    id: 23,
    projectName: 'Student Data App',
    projectDesc: 'An app to store information of students and have functinality to sort and filter',
    tags: ['Javascript', 'localStorage', 'Web Api'],
    code: 'https://github.com/dnyaneshwarmagar/student-management-system-dom',
    demo: 'https://student-acc-ms.netlify.app/',
    image: student_ms_vanillaJS
  },
  {
    id: 24,
    projectName: 'Employee Data App',
    projectDesc: 'An app to store information of employees and can perform crud',
    tags: ['Javascript', 'localStorage', 'Web Api'],
    code: 'https://github.com/dnyaneshwarmagar/profession-management-system',
    demo: 'https://profession-ms.netlify.app/',
    image: profession_manage_vanillJS
  },
  {
    id: 25,
    projectName: 'Restaurant App UI',
    projectDesc: 'UI of restaurant app',
    tags: ['Javascript', 'html', 'css'],
    code: 'https://github.com/dnyaneshwarmagar/pizza-restaurant',
    demo: 'https://pizza-reastaurant.netlify.app/',
    image: restaurant_basic_ui
  },
  {
    id: 26,
    projectName: 'Instagram App UI',
    projectDesc: 'An app to store information of students and have functinality to sort and filter',
    tags: ['Javascript', 'html', 'css'],
    code: 'https://github.com/dnyaneshwarmagar/insta-clone-plane',
    demo: 'https://insta-clone-plane.netlify.app/',
    image: insta_ui
  },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
